<template>
    <div id="app">
      <PptViewer :url="url" />
    </div>
  </template>
  
  <script>
  import PptViewer from './PptViewer.vue';
  export default {
    name: 'App',
    data(){
      return{
        url:""
      }
    },
    created(){
      this.url = this.$route.query.url
    },
    components: {
      PptViewer
    }
  }
  </script>
  